<template>
  <pano-container>
    <div class="page-title" :class="screen" v-if="hallTitle">{{ hallTitle }}</div>
    <div class="page-footer" :class="screen" v-show="data.id">
      <div class="image-list-wrap">
        <div v-for="(item,key) in imageList" :key="key" class="image-item" :class="{active: item.hall_id == $route.query.hall_id}" @click="select(item)">
          <img class="cover" :src="item.cover" alt />
          <div class="title ellipsis">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </pano-container>
</template>

<script>
import qs from '@halobear/utils/qs'
import { onBeforeMount, reactive, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useTravel from '@/composables/use-travel'

import PanoContainer from '@/components/pano-container'

export default {
  components: {
    PanoContainer,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      panoKey: '',
    })
    const {
      data = {},
      hallTitle,
      list,
      share,
    } = useTravel()

    // 横屏样式，暂时未用到
    const { screen = 'vertical' } = route.query

    const imageList = computed(() => {
      return list.value.filter((item) => item.cover)
    })

    
    const select = (item) => {
      router.replace({
        query: {
          ...route.query,
          id: item.id || '',
          hall_id: item.hall_id,
          hotel_id: item.hotel_id,
        },
      })
      // 防止获取不到正确url
      setTimeout(() => {
        state.panoKey = `pano_${item.hotel_id}_${item.hall_id}`
        share()
      }, 300)
    }

    onBeforeMount(() => {
      const { hall_id = '', hotel_id = '' } = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split('?')[1] || '')
      state.panoKey = `pano_${hotel_id}_${hall_id}`
    })

    return {
      state,
      list,
      imageList,
      data,
      select,
      hallTitle,
      screen,
    }
  },
}
</script>

<style lang="less" scoped>
.page-title {
  width: 750px;
  height: 92px;
  line-height: 92px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.36) 51%, rgba(0, 0, 0, 0) 100%);
  text-align: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  margin: auto;
  &.landscape {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
  }
}
.page-footer {
  width: 750px;
  height: 152px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.8) 100%);
  // border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0px;
  font-size: 28px;
  color: white;
  user-select: none;
  overflow-x: auto;
  &.landscape {
    transform: scale(0.5) translateY(50%);
  }
  .image-list-wrap {
    padding: 0 20px;
    overflow-x: auto;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none;
    }
    .image-item {
      display: inline-block;
      position: relative;
      width: 150px;
      height: 100px;
      margin: 0 10px;
      opacity: 0.85;
      &.active {
        opacity: 1.0;
        border: 2px solid white;
      }
      .cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle
      }
      .title {
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        font-size: 18px;
        text-align: center;
      }
    }
  }  
}
</style>
